<template lang="html">

  <article class="encuesta-el row-between" >
    <h3 class="titulo">{{prop.titulo}}</h3>
    <arrow-link class="arrow-link" :text="$t('comenzar')" :to="$t('enlaces.encuestas')+'/'+prop.urlAcceso"></arrow-link>
    <figure class="decorador"></figure>
    <router-link  :to="$t('enlaces.encuestas')+'/'+prop.urlAcceso" class="enlace-cover"></router-link>
  </article>

</template>

<script lang="js">
  import {mapGetters} from 'vuex';
    import arrowLink from '@/components/parts/icons/arrow-link';
  export default  {
    name: 'encuesta-el',
    props: ['prop'],
    components : {
      'arrow-link' : arrowLink
    },
    computed : { 
      ...mapGetters({
        data : 'getEncuestas',
        colors : 'basicColors',
        style : 'getStyles',
      }),
      ownstyles : function(){
        return {
          encuesta : {
            'background' : this.colors.light_black
          },
        }
      }
    }
  }
</script>

<style scoped lang="scss">
@import '@/assets/css/colors.scss';
.encuesta-el {
  width: 100%;
  padding:20px;
  padding-left: 25px;
  min-height: 80px;
  position: relative;
  margin-bottom: 40px;
  background: #F5FFDC;
}

.encuesta-el:last-of-type{
  margin-bottom: 0;
}

.encuesta-el .decorador{
  width: 10px;
  height: 100%;
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  background: #CDFF4F;
}

.titulo{
  font-family: Lato;
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  color: $primary;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/parts/encuesta-el.vue